import {mapGetters} from 'vuex';

// Texts of the Proweb migration banners. Admins can set them per enterprise, Norwegian
// falling back to English; without them the default wording below is shown.
export default {
  computed: {
    ...mapGetters('UserInfoStore', ['enterpriseSettings']),
    prowebBuyerBannerText() {
      const {prowebBannerTextEn, prowebBannerTextNb} = this.enterpriseSettings;

      return this.prowebTextForLanguage(prowebBannerTextEn, prowebBannerTextNb)
        || this.$gettext('Your organisation now books interpreters through TolkeNett. Please place new interpretation orders in TolkeNett. Existing assignments can still be viewed, changed and cancelled here.');
    },
    prowebAdminBannerText() {
      const {prowebAdminBannerTextEn, prowebAdminBannerTextNb} = this.enterpriseSettings;

      return this.prowebTextForLanguage(prowebAdminBannerTextEn, prowebAdminBannerTextNb)
        || this.$gettext('This customer has been migrated to TolkeNett. Their bookers are redirected to TolkeNett when creating new interpretation assignments. As an admin, you can still book on their behalf here.');
    }
  },
  methods: {
    prowebTextForLanguage(textEn, textNb) {
      return (this.$route.params.lang === 'nb' && textNb?.trim()) || textEn?.trim() || '';
    }
  }
};
